const theme = (theme) => ({
    ...theme,
    spacing: {
        ...theme.spacing,
        controlHeight: 30,
        baseUnit: 3,
    },
});

const customStyles = {
    control: (base) => ({
        ...base,
        zIndex: 900,
        border: '1px solid #ccc',
        borderRadius: 0,
        boxShadow: 'none',
        background: '#fff url(//s3-us-west-1.amazonaws.com/corefact-cdn/images/pngs/1x5/eee-ffffff00/75.png) repeat-x scroll left top',
        '&:hover': {
            border: '1px solid #ccc',
            outline: 'none',
        },
        '&:focus': {
            border: '1px solid #ccc',
            outline: 'none',
        },
    }),
    menuList: (base) => ({
        ...base,
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 0,
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
        marginTop: 0,
        zIndex: 999,
    }),
}

export {
    theme,
    customStyles,
}